module.exports = __webpack_public_path__ + "static/media/redeemIcon.13f899c7.svg";